export enum ManualPriceConditionEnum {
  EQUAL = 'equal',
  LESS_THAN = 'less_than',
  GREATER_THAN = 'greater_than',
}

export const ManualPriceConditionOptions = [
  { label: 'equal', value: ManualPriceConditionEnum.EQUAL },
  { label: 'lessThan', value: ManualPriceConditionEnum.LESS_THAN },
  { label: 'greaterThan', value: ManualPriceConditionEnum.GREATER_THAN },
];

export const getManualPriceCondition = (type: string): string => {
  const option = ManualPriceConditionOptions.find((option) => option.value === type);
  return option ? option.label : type;
};
